import 'reflect-metadata';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { Router } from './Router';
import { queryClient } from './services/datastore/react-query';
import { Toast } from './services/toast/Toast';
import { ToastRef } from './services/toast/utils';

import './utils/date';
import './index.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <>
          <Helmet>
            <title>Allocab</title>
          </Helmet>
          <Router />
          <Toast ref={ToastRef} />
          <ReactQueryDevtools initialIsOpen={false} position="bottom-left" />
        </>
      </QueryClientProvider>
    </HelmetProvider>
  </StrictMode>,
);
